

import { createContext } from "react";

/**
 * @type{import("react").Context<import("../../../../../types/Partidas/partidas.interfaces").PartidasReturnI>}
 */
const PartidasContext = createContext();

export default PartidasContext;